import { render, staticRenderFns } from "./heyueDetail.vue?vue&type=template&id=6d6bc788&scoped=true&"
import script from "./heyueDetail.vue?vue&type=script&lang=js&"
export * from "./heyueDetail.vue?vue&type=script&lang=js&"
import style0 from "./heyueDetail.vue?vue&type=style&index=0&id=6d6bc788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6bc788",
  null
  
)

export default component.exports